{
  "common": {
    "cancel": "Cancelar",
    "delete": "Eliminar",
    "save": "Guardar"
  },
  "fieldTypes": {
    "text": "Texto corto",
    "textarea": "Texto largo",
    "select": "Selección única",
    "multiselect": "Selección múltiple",
    "date": "Fecha",
    "number": "Número",
    "url": "URL",
    "boolean": "Sí/No"
  },
  "sections": {
    "personal": "Datos personales",
    "address": "Dirección",
    "social": "Redes sociales",
    "custom": "Información adicional"
  },
  "page": {
    "title": "Campos del perfil",
    "subtitle": "Configura los campos que los miembros completan en su perfil",
    "hidePreview": "Ocultar",
    "showPreview": "Vista previa",
    "newField": "Nuevo campo",
    "deleteSuccess": "Campo eliminado",
    "deleteError": "Error al eliminar el campo",
    "toggleError": "Error al modificar el campo",
    "empty": {
      "title": "Ningún campo personalizado",
      "description": "Crea campos personalizados que los miembros completan en su perfil",
      "create": "Crear el primer campo"
    },
    "deleteDialog": {
      "title": "Eliminar campo",
      "description": "¿Seguro que quieres eliminar el campo <bold>{{label}}</bold>? Se perderán todos los valores completados por los miembros."
    }
  },
  "preview": {
    "title": "Vista previa del perfil — como lo ve el miembro",
    "fixed": "fijo",
    "custom": "personalizado",
    "selectPlaceholder": "Selecciona",
    "personalDescription": "Completa tus datos principales",
    "fields": {
      "fullName": "Nombre completo",
      "fullNamePlaceholder": "Tu nombre completo",
      "email": "Email",
      "emailPlaceholder": "email@ejemplo.com",
      "cpf": "CPF",
      "phone": "Celular/WhatsApp",
      "birthDate": "Fecha de nacimiento",
      "birthDatePlaceholder": "DD/MM/AAAA",
      "occupation": "Ocupación",
      "occupationPlaceholder": "Ej.: Desarrollador Full Stack",
      "bio": "Bio",
      "bioPlaceholder": "Cuéntanos un poco sobre ti...",
      "zipCode": "Código postal",
      "state": "Estado/Provincia",
      "statePlaceholder": "Jalisco",
      "city": "Ciudad",
      "cityPlaceholder": "Guadalajara",
      "neighborhood": "Barrio",
      "neighborhoodPlaceholder": "Barrio",
      "street": "Calle",
      "streetPlaceholder": "Calle, Avenida...",
      "number": "Número",
      "usernamePlaceholder": "@tuusuario"
    }
  },
  "row": {
    "required": "obligatorio",
    "optionsCount_one": "{{count}} opción",
    "optionsCount_zero": "{{count}} opciones",
    "optionsCount_other": "{{count}} opciones",
    "deactivate": "Desactivar",
    "activate": "Activar",
    "edit": "Editar",
    "delete": "Eliminar"
  },
  "dialog": {
    "labelRequired": "El nombre del campo es obligatorio",
    "updated": "Campo actualizado",
    "created": "Campo creado",
    "saveError": "Error al guardar el campo",
    "editTitle": "Editar campo",
    "newTitle": "Nuevo campo",
    "label": "Nombre del campo *",
    "labelPlaceholder": "Ej.: Experiencia profesional",
    "type": "Tipo",
    "section": "Sección",
    "options": "Opciones (separadas por comas)",
    "optionsPlaceholder": "Opción A, Opción B, Opción C",
    "placeholder": "Texto de ejemplo",
    "placeholderPlaceholder": "Texto de ayuda dentro del campo",
    "helpText": "Texto de ayuda (opcional)",
    "helpTextPlaceholder": "Descripción que aparece debajo del campo",
    "required": "Campo obligatorio",
    "create": "Crear campo"
  }
}
